import React from 'react';
import t from 'shared/utils/translation';
import { BodyText, PageHeader } from '@grnhse/seedling/lib/azalea/typography';
import styled from 'styled-components';

const ErrorPage = () => (
  <Wrapper>
    <PageHeader>{t('self_schedule.error')}</PageHeader>
    <BodyText>{t('self_schedule.error_body')}</BodyText>
  </Wrapper>
);

const Wrapper = styled.div`
  margin: 65px 170px;

  @media only screen and (max-width: 480px) {
    margin: 65px 24px;
  }
`;

export default ErrorPage;
